"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.waiverAcceptanceFactory = void 0;
const Factory = require("factory.ts");
const uuid_1 = require("uuid");
const Mocks = require("../../../mocks");
exports.waiverAcceptanceFactory = Factory.Sync.makeFactory({
    id: Factory.each(i => uuid_1.v4()),
    waiver_id: Mocks.waiver.id,
    persona_id: 1,
    version_number: 1,
    created_at: Mocks.dates.date2000,
    updated_at: Mocks.dates.date2000,
});
